
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import * as _ from 'lodash';


@Component({
  selector: 'app-select-attach-print',
  templateUrl: './select-attach-print.component.html',
  styleUrls: ['./select-attach-print.component.scss']
})
export class SelectAttachPrintComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;  //已選資料_來源
  @Input() title: string; 
  mainDataList: Array<any>; //已選資料
  infoList: Array<any>;     //選項資料
  showList: Array<any>;     //顯示資料
  @Input() info : {//其他設定
    ORG_Company_ID: number,
    ORG_Store_ID: number,
    IsLoding:boolean
  };  
  query : {  //查詢選項
    searchKey : string
  } 
  status: { //當前狀態
    isSelectAll : boolean //是否已全選
    showType:number // 顯示有選過的
  }
  list={
    showType : [
      {name:"全部",value:0},
      {name:"已選",value:1},
      {name:"未選",value:2}]
  }


  modalRef = null;  //談窗鉤子
  
    //查詢的門市
    storeSelectList: selectData[];
    selectORG_Store_ID: number;

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
  ) { }

  //info 資料來源 = callAPI / 外部丟入
  //data 來源 =  MainData[ListName]
  
  //全選功能:
  // 撈取全部資料以提供全選 -  那麼分頁將不再重要 : 建議改成設定欄位
  // 全選讀取設定，非全選讀取陣列 
  // 同上問題，在經過搜尋之後的全選將有所刪減，因此除了"全選設定欄位"，還要加上查詢欄位，在後端進行查詢
  // 同上問題，過程中的其他方的新增，可能導致有額外資料產生。
  // 但不管是丟設定到後端查後取資，一開始取全資但顯示還是每頁只抓當頁資料，都可能造成以上問題。
  // 因此最佳處理還是一開始就丟出全部到前端顯示。 但如此行為可能導致效能緩慢? 
  // 單頁全選-可以正常運作

  ngOnInit(): void {
   this.query = { searchKey :""}
   
   
  }


  ngAfterViewInit(){    console.log('sa',this.info)
    this.onOpen(this.info, this.orgData)

   
  }



   //取得門市清單 API
 getStoreList() {//取得門市清單 USP_YOPOSWebGetStoreList

    



  this.http.post<any>('api/ORGStore/StoreList', {

    ORG_Company_ID: this.info.ORG_Company_ID,
    ORG_Store_ID: this.info.ORG_Store_ID,
  }).subscribe({
    next: data => {

      this.storeSelectList = [];


      //門市共用下拉選單
      let Item :any= {};
      Item.value = 0;
      Item.content = '總部';
      this.storeSelectList.push(Item);
  
      if(this.info.ORG_Store_ID ){
  
           //門市共用下拉選單
           let Item :any= {};
           Item.value = this.info.ORG_Store_ID;
           Item.content = data.LIST.find(x=>x.ORG_Store_ID == this.info.ORG_Store_ID ).StoreName;
           this.storeSelectList.push(Item);
  
      }else{

        data.LIST.forEach(element => {
          //門市共用下拉選單
          var selectItem = new selectData();
          selectItem.value = element.ORG_Store_ID;
          selectItem.content = element.StoreName;
          this.storeSelectList.push(selectItem);
        });
  
  
      }
    

      

      


      // 預設點第一個
      if (this.storeSelectList.length > 0) {
        this.selectORG_Store_ID = this.storeSelectList[0].value
      }
    },
    error: error => {
      console.error('There was an error!', error);
    }
  });

}



  //打開選擇附加品項

  @ViewChild('Modal') Modal :TemplateRef<any>
  onOpen(info,data) {
   this.getStoreList()

    if(info){
      this.info = info
    }
    if(data){
      this.orgData = data
    }
      
    //初始化查詢資料
    this.query.searchKey = ""
    this.mainDataList = []
    this.status= { 
      isSelectAll : true,
      showType:0
    }
    
    //處理已選資料
    if(this.orgData && this.orgData.length > 0){      
      this.mainDataList = _.cloneDeep(this.orgData)
      // this.orgDataList.forEach(x => {
      //   let obj = _.assign({}, x)
      //   this.mainDataList.push(obj)
      // })
    }    
    
    //撈取可選資料 並合成已選資料
    this.onQuery() 

    //開啟談窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  //查詢
  onQuery( ) {
    
    this.getInfoList((data)=>{
      
      //初始化
      this.infoList = data
      this.showList = data
      this.showList.forEach(x => {

        let obj = _.find(this.mainDataList, y => this.judgeSame(y,x))
        if (obj) {
          x.isSelect = true
        } else {
          x.isSelect = false
        }
      })

      this.filterShowType()
      this.judgeSelectAll()

    });

  }

  onShowType(){
    this.filterShowType()
    this.judgeSelectAll()
  }

  //選擇
  onSelect(isAdd:boolean, item ) {
    if(isAdd){
      item.isSelect = true
      item.Sorting = 0
      this.mainDataList.push(item);

    }else{
      item.isSelect = false
      let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
      this.mainDataList.splice(index, 1);
    }    

    this.judgeSelectAll()
  }

  //全選
  onSelectAll(){
    
    
    if(this.status.isSelectAll){
      this.showList.forEach(item=>{
        item.isSelect = false
        let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
        this.mainDataList.splice(index, 1);
      })
    }
    else{      
      this.showList.forEach(item=>{
        item.isSelect = true
        item.Sorting = 0
        this.mainDataList.push(item);
      })
    }
    
    this.status.isSelectAll = !this.status.isSelectAll
  }

  //處存
  onSave() {
    
    this.orgData.splice(0,this.orgData.length );
    let i = 1;
    this.mainDataList.forEach(x=>{      
      // x.Sorting = i;
      // i++
      this.orgData.push(x)
    })

    
    //TODO  確認附加品項表格中修改後 會影響到此嗎?  應該禁止修改名稱
    this.emitList.emit(this.orgData)
    this.modalRef.close()


    //重新計算順序 並且重載列表資料
    // var i = 1;
    // this.mainDataList.forEach(function (data) {
    //   data.Sorting = i;
    //   i++
    // });
    // this.orgDataList.load(this.mainDataList);

  }

  //--------------------------------------------------------------------
  
 
  //過濾已選未選等
  filterShowType(){
    if(this.status.showType==0){
      this.showList = _.concat([],this.infoList)
    }
    else if(this.status.showType==1){
      this.showList = _.filter(this.infoList,x=>x.isSelect)
    }
    else{
      this.showList = _.filter(this.infoList,x=> !x.isSelect)
    }
  }

  //判斷是否全選
  judgeSelectAll(){
    if(!this.showList || this.showList.length==0){
      return true
    } 
  
    this.status.isSelectAll = this.showList.every(x=>{
      return this.mainDataList.some(y=>this.judgeSame(y,x))    
    })
    

  }


//--------------------------------------------客製化------------------------------------------------------
  //比較
  judgeSame(y , x){
    return y.PRDAttachItemNo == x.PRDAttachItemNo
    // y.PRDProductNo == x.PRDProductNo &&
    // y.PRDProductGroupNo == x.PRDProductGroupNo 
    
  }

  //取得選擇附加品項清單
  getInfoList( callback) {
    //取得含有商品的附加品項
    this.info.IsLoding= true
    this.http.get<any>(
      `api/AttachItemSetting/GetAttachPrintItemOptionList?` +        
      `ORG_Company_ID=${this.info.ORG_Company_ID}`+
      ((this.query.searchKey == null || this.query.searchKey == '') ? '' : ('&keyword=' + this.query.searchKey)) +
      `${this.selectORG_Store_ID !=null ? "&CreateStore=" + this.selectORG_Store_ID : ''}`+
      '&IsDelete=' + false +'&Page=' + 1+'&PerPage=' + 2147483647
    ).subscribe({
      next: data => {

        if(callback)
          callback(data.LIST)

        // data.LIST.forEach(element => {
        //   //門市共用下拉選單
        //   let item = {};
        //   item.PRDAttachItemNo = element.PRDAttachItemNo;
        //   item.AttachItemName = element.AttachItemName;
        //   item.PRDProductGroupNo = element.PRDProductGroupNo;
        //   item.PRDProductNo = element.PRDProductNo;
        //   item.Quantity = element.Quantity;
        //   item.Cash = element.Cash;
        //   item.ProductName = element.ProductName;
        //   item.ItemName = element.ItemName;

        // });


        this.info.IsLoding= false
      },
      error: error => {
        //this.errorMessage = error.message;
        console.error('There was an error!', error);
        this.info.IsLoding= false

      }
    });

  }



}











//  參考資料
// $scope.shared.quickStoreNew = {
//   mOName: "#shared-quickStoreNew",
//   disableChoose: null, //禁止選擇
//   motype: null,// 1:普通,2:公司已固定
//   type: null, //標題類型
//   SelectType: 2, // 1-單選 2-多選
//   pagelistinfo: null, //分頁資料
//   companyId: "",//公司ID
//   condiName: "",//查詢文字                
//   returnObj: [],//結果物件 多選[] 單選{}
//   detail: [], //單頁資料
//   allDetail: [],  //全部資料
//   resultFun: null,//回傳時觸發        
//   allSelectName: '全選',
//   onePageSelectName: '本頁全選',
//   keyFN: {
//     S_list: 'storeId', //商店列表關鍵字
//     S_return: 'storeId', //回傳物件關鍵字
//   },
//   transf_return: function (obj_list, active) { ///回傳物件需求欄位
//     return {
//       storeId: obj_list.storeId,
//       store: obj_list.store,
//       companyId: obj_list.companyId,
//       company: obj_list.company,
//       active: active
//     }
//   },
//   transf_list: function (obj_api) { ///商店列表需求欄位
//     return {
//       storeId: obj_api.storeId,
//       store: obj_api.store,
//       companyId: obj_api.companyId,
//       company: obj_api.company,
//       active: false
//     }
//   },
//   API_getAllList: svr_marketing.shared.getAllStores,
//   API_getList: svr_marketing.shared.getStores,
//   open: function (obj, disableChoose, defCompany, SelectType, resultFun) {
//     let my = $scope.shared.quickStoreNew
//     $(my.mOName).modal('show')
//     my.disableChoose = !disableChoose ? false : disableChoose;


//     //初始化              
//     my.condiName = '';
//     if (my.pagelistinfo)
//       my.pagelistinfo.pageindex = 1


//     //取得原始資料
//     if (defCompany) {
//       my.companyId = defCompany;
//     }

//     my.title = '選擇門市';
//     if (!obj) obj = [];
//     my.returnObj = obj;
//     if (!SelectType) SelectType = 2
//     my.SelectType = SelectType
//     my.resultFun = resultFun

//     my.find()
//   },
//   find: function () {
//     let my = $scope.shared.quickStoreNew
//     //取得單頁資料
//     my.getDetail(function () {
//       my.showItem(my.detail)
//       my.showBtnName(2)
//     });
//     //取得全部資料
//     my.getAllDetail(function () {
//       my.showBtnName(1)
//     });
//   },
//   onPage: function () {
//     let my = $scope.shared.quickStoreNew
//     //取得單頁資料
//     my.getDetail(function () {
//       my.showItem(my.detail)
//       my.showBtnName(2)
//     });
//   },
//   onSelect: function (x, active) {
//     let my = $scope.shared.quickStoreNew
//     switch (my.SelectType) {

//       case 1:
//         // my.returnObj.store = x.store;
//         // my.returnObj.storeId = x.storeId;
//         Object.assign(my.returnObj, transf(x, null))
//         $(mOName).modal('hide');
//         break;
//       default:
//         let arr = []
//         arr.push(x)

//         my.showItem(arr, active)
//         my.showBtnName(1)
//         my.showBtnName(2)


//         break;

//     }

//     if (my.resultFun)
//       my.resultFun()
//   },
//   onSelectAll: function (type) {
//     let my = $scope.shared.quickStoreNew
//     let storeList = {}
//     if (type == 1)
//       storeList = my.allDetail
//     else
//       storeList = my.detail

//     let active = 1
//     let t_Num = 0

//     //判斷 T or F :項目非以全選時 改成全部取消
//     storeList.forEach(x => {
//       let foo = my.returnObj.find(y => y[my.keyFN.S_return] == x[my.keyFN.S_list] && y.active)
//       if (foo) {
//         t_Num++;
//       }
//     })
//     if (t_Num == storeList.length) {
//       active = 0
//     }
//     else {
//       active = 1
//     }

//     //塞入
//     my.showItem(storeList, active)
//     my.showBtnName(1)
//     my.showBtnName(2)

//     if (my.resultFun)
//       my.resultFun()

//   },
//   showItem: function (dataList, active) {
//     let my = $scope.shared.quickStoreNew
//     //判斷是否塞入
//     dataList.forEach(x => {
//       //待回傳資料

//       let apiD = null
//       if (my.SelectType == 2) //多選
//         apiD = my.returnObj.find(y => y[my.keyFN.S_return] == x[my.keyFN.S_list])
//       else  //單選
//         apiD = my.returnObj

//       //初始化資料 : 單頁
//       if (active == null || active == undefined) {
//         if (apiD) {
//           x.active = apiD.active
//         }
//       }
//       //點擊事件 :全選、頁選、單選
//       else {
//         let pageD = my.detail.find(y => y[my.keyFN.S_list] == x[my.keyFN.S_list])
//         if (pageD)
//           pageD.active = active

//         //灌入資料
//         if (apiD) {
//           apiD.active = active;
//         }
//         else {
//           my.returnObj.push(
//             my.transf_return(x, active))

//         }
//       }


//     })
//   },
//   showBtnName: function (type) {
//     let my = $scope.shared.quickStoreNew
//     //只有多選需要執行此工作
//     if (my.SelectType != 2) return

//     let storeList = {}
//     if (type == 1)
//       storeList = my.allDetail
//     else
//       storeList = my.detail


//     //項目非已全選時 改成全部取消
//     let t_NumA = 0

//     storeList.forEach(x => {
//       let foo = my.returnObj.find(y => y[my.keyFN.S_return] == x[my.keyFN.S_list] && y.active)
//       if (foo) {
//         t_NumA++;
//       }
//     })

//     if (type == 1)
//       my.allSelectName =
//         (t_NumA == storeList.length) ? '取消' : '全選'
//     else
//       my.onePageSelectName =
//         (t_NumA == storeList.length) ? '本頁取消' : '本頁全選'
//   },
//   getAllDetail: function (callback) {
//     let my = $scope.shared.quickStoreNew
//     //只有多選需要執行此工作
//     if (my.SelectType != 2) return

//     //初始化
//     my.allDetail = [];
//     //參數

//     let par = {}
//     par.store = my.condiName
//     par.companyId = my.companyId
//     //呼叫
//     my.API_getAllList(par, function (data) {
//       let result = data.contentData.content
//       my.allDetail = result.map(x => my.transf_list(x));

//       callback()
//     });
//   },
//   getDetail: function (callback) {
//     let my = $scope.shared.quickStoreNew
//     //初始化
//     my.detail = [];
//     //參數                  
//     let par = null
//     if (my.pagelistinfo)
//       par = { pageindex: my.pagelistinfo.pageindex };
//     else
//       par = { pageindex: 1 };
//     par.store = my.condiName;
//     par.companyId = my.companyId
//     //呼叫
//     my.API_getList(par, function (data) {
//       let result = data.contentData.content
//       my.detail = result.map(x => my.transf_list(x));
//       my.pagelistinfo = data.contentData.pageinfo;

//       callback()
//     });


//   },
// }


class selectData {
  value: number;//
  content: string;//
  info:string
}